<script>
  import { mapState } from 'vuex'

  export default {
    computed: {
      ...mapState("navigation", ["breadcrumbItems"])
    },
  }
</script>

<template>
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <b-breadcrumb :items="breadcrumbItems" class="m-0"></b-breadcrumb>
      </div>
    </div>
  </div>
  <!-- end page title -->
</template>
